import React, { FC } from "react";
import styled from "styled-components";
import { Image } from "@evergis/ui";

import { HeaderLogo as Logo } from "../../../components/Logo/HeaderLogo";

import { useConfigSettings } from "../../../hooks/useConfigSettings";

const PageContainer = styled.div`
  padding: 2rem;
  box-sizing: border-box;
`;

const LogoContainer = styled.div`
  margin-bottom: 2rem;

  #custom-logo {
    position: absolute;
  }
`;

export const PageLayout: FC = ({ children }) => {
  const { isLoading, customLogo } = useConfigSettings();

  return (
    <PageContainer>
      {!isLoading && (
        <LogoContainer>
          {customLogo ? (
            <>
              <Image id="custom-logo" src={customLogo.src} width={customLogo.width} height={customLogo.height} />
              {customLogo.preserveText && <Logo hideLogo offsetLeft={`${(customLogo.width ?? 0) - 35}px`} />}
            </>
          ) : (
            <Logo />
          )}
        </LogoContainer>
      )}
      {children}
    </PageContainer>
  );
};
